import React from 'react';

import { DualCoordinateDepthRange } from '@da-g3-acl/shared/common';

import { IntervalsData } from './IntervalLaneRowProvider';

export type UpdateIntervalFn = (
	datasetId: string,
	original: DualCoordinateDepthRange,
	modified: DualCoordinateDepthRange,
	isComplete: boolean,
) => void;
export interface IntervalModifierKeys {
	ctrl: boolean;
}
export type CreateIntervalFn = (
	datasetId: string,
	drawn: DualCoordinateDepthRange,
	isComplete: boolean,
	modifiers: IntervalModifierKeys,
) => void;

export interface IntervalDataContextProps {
	intervals: IntervalsData;
	onIntervalUpdating?: UpdateIntervalFn;
	onIntervalCreating?: CreateIntervalFn;
}

export const IntervalDataContext = React.createContext<IntervalDataContextProps>({
	intervals: {},
});
